// @flow
/** @jsx isolateComponent */

import { AsyncSearch, GridLayout, Icon, Text } from '@zapier/common-components';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

import Required from 'app/beta-editor/components/Required';

import ZapOwner from './ZapOwner';
import ZapOwnerMenuItem from './ZapOwnerMenuItem';

import type {
  OnSearchMembersType,
  TeamMemberType,
} from '@zapier/team/src/types';

type Props = {
  /** True to allow user to transfer */
  canTransfer: boolean,
  /** True to show loading */
  isLoading: boolean,
  /** Called to search account members */
  onSearchMembers: OnSearchMembersType,
  /** Called to select a new owner */
  onSelectOwner: TeamMemberType => void,
  /** Chosen owner of the Zap */
  newOwner: TeamMemberType,
  /** Title of the Zap being transferred */
  zapTitle: string,
};

const Styles = labelStyles(__filename, {
  adminMessage: {
    alignItems: 'center',
    display: 'flex',
  },
  title: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: '1.5em',
  },
  body: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: '1em',
  },
  transferMessage: {
    marginTop: '1.5em',
    marginBottom: '1.5em',
  },
});

const ZapOwnerEdit = (props: Props) => {
  return (
    <GridLayout gap={4}>
      <div css={Styles.title}>
        <h3>
          <Text type="main-head-strong">Transfer Ownership</Text>
        </h3>
      </div>
      <div css={Styles.body}>
        <Text type="body-strong">
          Choose a new owner <Required />
        </Text>
        <div css={Styles.adminMessage}>
          <Icon color="steel" margin={{ right: 5 }} name="info" />{' '}
          <Text color="batmobile" type="fine">
            Owners will be granted access to folders and authentications
          </Text>
        </div>
      </div>

      {props.canTransfer && (
        <AsyncSearch
          getKeyForItem={item => item.id}
          menuAriaLabel="List of available members"
          MenuItemComponent={ZapOwnerMenuItem}
          onChange={props.onSelectOwner}
          onInputValueChange={props.onSearchMembers}
          placeholder="Search for a new owner..."
        />
      )}
      {props.newOwner.id && (
        <div css={Styles.transferMessage}>
          <Text type="body">
            Transfering <em>{props.zapTitle}</em> to:
          </Text>
          <ZapOwner member={props.newOwner} />
        </div>
      )}
    </GridLayout>
  );
};

export default ZapOwnerEdit;
